import { getTemplate } from "../template-helper.js";

const COMPONENT_NAME = "z-html";
const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register() {
    // return getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template) => {
        class HTMLComponent extends HTMLElement {
            constructor() {
                super();
                this.innerHTML = null;
            }
    
            init() {
                this.innerHTML = "";
                this.inputHidden = document.createElement("input");
                this.inputHidden.className="d-none" ;
                this.appendChild(this.inputHidden);

                this.applyRequired();

                const composer = document.createElement('iframe');
                composer.src = TEMPLATE_URL;
                composer.style = "border:0;margin:0;padding:0;width:100%;height:100%;display:block";
                this.style = "border:0px;padding:0;display:block;width:100%;height:100%";
                this.appendChild(composer);
    
                if (composer.contentWindow) {
                    composer.contentWindow.tr = window.tr ;
                    composer.contentWindow.locale = window.locale ;

                    let app = window.APP ;
                    if(this.hasAttribute("z-app")){
                        if(window.APPS[this.getAttribute("z-app")]){
                            app = window.APPS[this.getAttribute("z-app")] ;
                        }
                    }

                    composer.contentWindow.APP = app ;
                    composer.contentWindow.jwt = localStorage.getItem("jwt-token") ;
                    composer.contentWindow.type = this.getAttribute("z-html-type") ;

                    composer.contentWindow.onDidInit = function () {
                        this.editor = composer.contentWindow.editor;
                        this.editor.setData(this.currentValue || this.getAttribute('value') || "");
                        this.applyReadonly() ;
                        var onChange = ()=>{
                            // console.log("settingValueInProgress??", this.settingValueInProgress) ;
                            if(!this.settingValueInProgress){
                                this.dispatchEvent(new Event("change", { bubbles: true }));
                                this.inputHidden.value=this.value;
                            }
                        } ;
                        this.editor.on('change', onChange) ;
                        this.editor.on('afterPaste', onChange) ;
                        this.editor.on('afterPasteFromWord', onChange) ;
                        this.editor.on('afterUndoImage', onChange) ;
                        this.editor.on('mode', ()=> {
                            if (this.editor.mode === 'source') {
                                var editable = this.editor.editable();
                                editable.attachListener(editable, 'input', onChange);
                            }
                        });
                    }.bind(this);
                }
    
                // this.div = this.querySelector(".z-html-container") ;
                // if(!this.div){
                //     const clone = document.importNode(template.content, true);
                //     this.appendChild(clone);
                //     this.div = this.querySelector(".z-html-container") ;
                // }
    
                // const rootNode = this.getRootNode();
                // if(!rootNode || !rootNode.getElementById){ 
                //     return  ;
                // }
    
                // this.doImport().then(()=>{
                //     window.CKEDITOR.disableAutoInline = true;
                //     window.CKEDITOR.inline( this.div );
                // });
            }
    
            connectedCallback() {
                this.init();
            }
    
            doImport() {
                let rootNode = this.getRootNode();
                if(rootNode === this) { return Promise.resolve(); }
                if(!rootNode || !rootNode.getElementById){ return Promise.resolve(); }
    
                let head = rootNode;
                if(rootNode.head){
                    head = rootNode.head ;
                }
    
                const styleTag = rootNode.getElementById("style_z_html") ;
                if(styleTag){ return rootNode.importPromise; }
                
                var sInline = document.createElement('style');
                sInline.id = "style_z_html" ;
                sInline.setAttribute('type', 'text/css');
                sInline.appendChild(document.createTextNode(`
                `));
                head.appendChild(sInline);
    
                rootNode.importPromise = Promise.all([
                    "/node_modules/ckeditor4/ckeditor.js",
                ].map(src=>{
                    return new Promise((resolve, reject)=>{
                        let script = document.createElement("script");
                        script.async = true;
                        script.type = "text/javascript";
                        script.src = src;
                        script.onload = function(_, isAbort) {
                            if (!script.readyState || "complete" === script.readyState) {
                                if (isAbort){
                                    reject("can't load ckeditor.js") ;
                                }else{
                                    resolve() ;
                                }
                            }
                        };
                        
                        script.onreadystatechange = script.onload ;
                        
                        script.onerror = function () {
                            reject("can't load ckeditor.js") ;
                        };
                        
                        head.appendChild(script);
                    }) ;
                })) ;
                
                return rootNode.importPromise;
            }
    
            get value() {
                if(!this.editor){
                    return this.currentValue ;
                }
                if (this.editor.getData() === '<p><br></p>') {
                    return null;
                }
                return this.editor.getData();
            }
    
            set value(value) {
                if(!this.settingValueInProgress){
                    this.settingValueInProgress = 0;
                }
                this.settingValueInProgress++;
                // console.log("settingValueInProgress", this.settingValueInProgress, value) ;
                try{
                    this.currentValue = value;
                    if (this.editor) {
                        this.editor.setData(this.currentValue || "");
                        this.applyReadonly();
                        setTimeout(()=>{
                            // console.log("set data", this.settingValueInProgress, this.currentValue ) ;
                            this.editor.setData(this.currentValue || "");
                            this.applyReadonly();
                        }, 1);
                    }
                }finally{
                    setTimeout(()=>{
                        this.settingValueInProgress--;
                        // console.log("settingValueInProgress--", this.settingValueInProgress) ;
                    }, 10) ;
                }
                this.inputHidden.value=value;
            }
    
            static get observedAttributes() {
                return ['value', 'readonly', 'z-app', "required"];
            }

            get required() {
                return this.hasAttribute("required");
            }

            set required(required) {
                if(required){
                    this.setAttribute('required', required);
                }else{
                    this.removeAttribute('required');
                }
                this.applyRequired() ;
            }

            setCustomValidity(msg){
                this.customValidity = msg ;
                if(this.inputHidden){
                    this.inputHidden.setCustomValidity(msg) ;
                }
            }
    
            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'value':
                        this.value = newValue;
                        break;
                    case 'readonly':
                        this.applyReadonly();
                        break;
                    case 'required':
                        this.applyRequired() ;
                        break;
                    case 'z-app':
                        this.init();
                        break;
                }
            }
    
            applyReadonly() {
                if (this.editor) {
                    try{
                        return this.editor.doSetReadOnly(this.hasAttribute('readonly'));
                    }catch(err){
                        console.error("Can't set readonly", err) ;
                    }
                }
            }

            applyRequired() {
                this.isRequired = this.hasAttribute("required") ;
                if(this.isRequired){
                    this.inputHidden.setAttribute('required', this.isRequired);
                }else{
                    this.inputHidden.removeAttribute('required');
                }
            }

            focus(){
                if (this.editor) {
                    this.editor.focus() ;
                }
            }
        }
        customElements.define(COMPONENT_NAME, HTMLComponent);
    // });
}
